module.exports = __webpack_public_path__ + "media/images/front/sp/article/female-f6b63390dfd4bfd17b1aac2cd03bdc7e.png";